module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\" id=\"profile-container\">\n\t<profile ng-profile-uid=\"userProfileCtrl.profile_uid\"\n\t         ng-field-set=\"'form-horizontal'\"\n\t></profile>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/users/account/profile/template.html
// module id = 299
// module chunks = 0